import APIManager from "../connection/APIManager"
import AuthBuildHeaderUserObject from "./AuthBuildHeaderUserObject"

/*
USE CASE: WorksMonitorDeleteItem
Desc: Caso de uso responsável por deletar um item da api no servidor, 
devolvendo resolve caso o item seja excluido com sucesso e reject caso ocorra algum erro.
params: 
   - item: Recebe um id de um item especifico de um determinado array para que seja feito o delete desse determinado item.
returns:
  - Uma promise que retorna resolve caso o item seja excluido com sucesso e reject caso ocorra algum erro.
*/
const WorksMonitorDeleteItem = (trabalho_id) => {
  return new Promise(async (resolve, reject) => {
    let headers = await AuthBuildHeaderUserObject().catch(e => {return null})
    if(!headers) return reject()

    let NewHeaders = {
        ...headers,
        trabalho_id: trabalho_id
    }

    APIManager.send("/trabalho/resumo","DELETE",NewHeaders).then(res => {
        return res
    }).then(res => {
        resolve(res)
    }).catch(e => {
        reject(e)
    })
})
}
export default WorksMonitorDeleteItem;
